// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../../uikit/atoms/Icon/IconV5.bs.js");
let Heading__Jsx3 = require("../../../../uikit/reason/helpers/Heading__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function PropertyAddressValidationCallout(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            props.icon === "Error" ? JsxRuntime.jsx(IconV5.make, {
                icon: "cancel",
                size: 16,
                className: "text-tan-error-500"
              }) : JsxRuntime.jsx(IconV5.make, {
                icon: "attention-alt",
                size: 30,
                className: "text-black"
              }),
            JsxRuntime.jsx(Heading__Jsx3.make, {
              as_: "h5",
              children: props.heading
            })
          ],
          className: "flex flex-row items-center gap-2"
        }),
        props.children
      ],
      className: "flex flex-col items-stretch gap-2 p-1"
    }),
    className: "border border-tan-error-500 p-2"
  });
}

let make = PropertyAddressValidationCallout;

exports.make = make;
/* IconV5 Not a pure module */
